var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.5 20.5",
    style: {
      enableBackground: "new 0 0 20.5 20.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,3H6c0.1-1.7,1.5-3,3.2-3h2c1.7,0,3.1,1.3,3.2,3h0.3c0.9,0,1.6,0,2.2,0.1c0.6,0.1,1.1,0.2,1.6,0.4 c0.6,0.3,1,0.8,1.4,1.4c0.3,0.5,0.4,1,0.4,1.6c0.1,0.6,0.1,1.3,0.1,2.2v0.1c0,0.9,0,1.6-0.1,2.2c-0.1,0.6-0.2,1.1-0.4,1.6 c-0.1,0.1-0.2,0.3-0.2,0.4h-6.9c-0.3-1.2-1.4-2-2.6-2s-2.3,0.8-2.6,2H0.8c-0.1-0.1-0.2-0.2-0.2-0.4c-0.3-0.5-0.4-1-0.4-1.6 C0,10.4,0,9.7,0,8.8V8.7c0-0.9,0-1.6,0.1-2.2c0.1-0.6,0.2-1.1,0.4-1.6c0.3-0.6,0.8-1,1.4-1.4c0.5-0.3,1-0.4,1.6-0.4 C4.1,3,4.8,3,5.7,3z M13,3H7.5c0.1-0.8,0.9-1.5,1.7-1.5h2C12.1,1.5,12.9,2.2,13,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14.5h-6.1c-0.3,1.2-1.4,2-2.6,2s-2.3-0.8-2.6-2H1.5c0,1.1,0,1.9,0.1,2.6c0.1,0.9,0.4,1.7,1,2.3c0.6,0.6,1.4,0.9,2.3,1 c0.9,0.1,2,0.1,3.3,0.1h4.1c1.4,0,2.5,0,3.3-0.1c0.9-0.1,1.7-0.4,2.3-1c0.6-0.6,0.9-1.4,1-2.3C19,16.4,19,15.6,19,14.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2,12.2c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S11.1,12.2,10.2,12.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.31d1f18dd1b7f88d4f3f98807930d0f8.svg";
export { ForwardRef as ReactComponent };